import blog1 from "../../images/blog/blog-1-1.jpg";
import blog2 from "../../images/blog/blog-1-2.jpg";
import blog3 from "../../images/blog/blog-1-3.jpg";

const Blogs = () => {
    return(
        <section className="blog-one">
            <div className="container">
                <div className="section-title text-center">
                    <span className="section-title__tagline">From the Blog</span>
                    <h2 className="section-title__title">News & Articles</h2>
                </div>
                <div className="row">
                    <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
                        <div className="blog-one__single">
                            <div className="blog-one__img">
                                <img src= { blog1 } alt=""/>
                                <div className="blog-one__date">
                                    <p>26 oct</p>
                                </div>
                                <a href="blog-details.html">
                                    <span className="news-one__plus"></span>
                                </a>
                            </div>
                            <div className="blog-one__content">
                                <ul className="list-unstyled blog-one__meta">
                                    <li><a href="blog-details.html"><i className="far fa-user-circle"></i> Admin</a></li>
                                    <li><a href="blog-details.html"><i className="far fa-comments"></i> 2 Comments</a>
                                    </li>
                                </ul>
                                <h3 className="blog-one__title">
                                    <a href="blog-details.html">Start a Fundraiser for
                                        Yourself</a>
                                </h3>
                                <p className="blog-one__text">Aellentesque porttitor lacus quis enim varius sed efficitur...
                                </p>
                                <div className="blog-one__bottom">
                                    <a href="blog-details.html" className="blog-one__btn">Read More</a>
                                    <a href="blog-details.html" className="blog-one__arrow"><span
                                            className="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="200ms">
                        <div className="blog-one__single">
                            <div className="blog-one__img">
                                <img src={ blog2 } alt=""/>
                                <div className="blog-one__date">
                                    <p>26 oct</p>
                                </div>
                                <a href="blog-details.html">
                                    <span className="news-one__plus"></span>
                                </a>
                            </div>
                            <div className="blog-one__content">
                                <ul className="list-unstyled blog-one__meta">
                                    <li><a href="blog-details.html"><i className="far fa-user-circle"></i> Admin</a></li>
                                    <li><a href="blog-details.html"><i className="far fa-comments"></i> 2 Comments</a>
                                    </li>
                                </ul>
                                <h3 className="blog-one__title">
                                    <a href="blog-details.html">School Counseling for Children</a>
                                </h3>
                                <p className="blog-one__text">Aellentesque porttitor lacus quis enim varius sed efficitur...
                                </p>
                                <div className="blog-one__bottom">
                                    <a href="blog-details.html" className="blog-one__btn">Read More</a>
                                    <a href="blog-details.html" className="blog-one__arrow"><span
                                            className="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="300ms">
                        <div className="blog-one__single">
                            <div className="blog-one__img">
                                <img src= { blog3 } alt=""/>
                                <div className="blog-one__date">
                                    <p>26 oct</p>
                                </div>
                                <a href="blog-details.html">
                                    <span className="news-one__plus"></span>
                                </a>
                            </div>
                            <div className="blog-one__content">
                                <ul className="list-unstyled blog-one__meta">
                                    <li><a href="blog-details.html"><i className="far fa-user-circle"></i> Admin</a></li>
                                    <li><a href="blog-details.html"><i className="far fa-comments"></i> 2 Comments</a>
                                    </li>
                                </ul>
                                <h3 className="blog-one__title">
                                    <a href="blog-details.html">Growing Up children in Charity Care</a>
                                </h3>
                                <p className="blog-one__text">Aellentesque porttitor lacus quis enim varius sed efficitur...
                                </p>
                                <div className="blog-one__bottom">
                                    <a href="blog-details.html" className="blog-one__btn">Read More</a>
                                    <a href="blog-details.html" className="blog-one__arrow"><span
                                            className="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Blogs;